var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _rect3, _path9, _rect4, _path0, _rect5, _path1, _rect6, _path10, _path11, _rect7, _rect8, _rect9, _path12, _rect0, _path13, _path14, _rect1, _path15, _rect10, _path16, _path17, _path18, _path19, _path20, _rect11, _rect12, _rect13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgProfileMatchModal = function SvgImgProfileMatchModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 228 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.999,
    cy: 146.645,
    rx: 35.621,
    ry: 9.355,
    fill: "#B5EEC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13 80.644a9.864 9.864 0 0 1 5.682-11.081L47.657 52.5c4.053-1.78 8.718.612 9.638 4.942l11.772 55.406a9.863 9.863 0 0 1-5.681 11.08L24.54 140.991c-4.053 1.78-8.718-.612-9.638-4.942L3.131 80.643Z",
    fill: "#EBF9EE",
    stroke: "#000",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.141 90.958a6.324 6.324 0 0 1 3.643-7.104l9.662-4.244a4.6 4.6 0 0 1 6.348 3.255l3.237 15.233a6.323 6.323 0 0 1-3.643 7.104l-9.662 4.244c-2.67 1.173-5.742-.403-6.348-3.255L12.14 90.958ZM33.93 77.584a1.93 1.93 0 0 1 1.112-2.17l16.53-7.26a1.404 1.404 0 0 1 1.938.994 1.93 1.93 0 0 1-1.112 2.168l-16.53 7.261a1.404 1.404 0 0 1-1.938-.993ZM35.416 83.49a1.93 1.93 0 0 1 1.112-2.17l16.53-7.26a1.404 1.404 0 0 1 1.939.993 1.93 1.93 0 0 1-1.112 2.169l-16.53 7.26a1.404 1.404 0 0 1-1.939-.993ZM36.91 89.394a1.93 1.93 0 0 1 1.113-2.168l16.53-7.261a1.404 1.404 0 0 1 1.938.993 1.93 1.93 0 0 1-1.112 2.17l-16.53 7.26a1.404 1.404 0 0 1-1.938-.994Z",
    fill: "#D6F4DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13 80.644a9.864 9.864 0 0 1 5.682-11.081L47.657 52.5c4.053-1.78 8.718.612 9.638 4.942l.345 1.623L3.59 82.806l-.46-2.162Z",
    fill: "url(#img-profile-match-modal_svg__a)",
    stroke: "#000",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.869 42.675a9.864 9.864 0 0 0-5.681-11.08l-38.845-17.063c-4.053-1.78-8.718.611-9.638 4.941L158.933 74.88a9.864 9.864 0 0 0 5.681 11.08l38.845 17.063c4.053 1.781 8.718-.612 9.638-4.942l11.772-55.405Z",
    fill: "#EBF9EE",
    stroke: "#000",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.516 43.739a6.324 6.324 0 0 0-3.642-7.105l-9.662-4.244c-2.67-1.172-5.743.403-6.349 3.255l-3.236 15.233a6.324 6.324 0 0 0 3.642 7.104l9.662 4.245c2.67 1.172 5.743-.403 6.349-3.255l3.236-15.233ZM216.657 50.453a1.93 1.93 0 0 0-1.112-2.169l-16.53-7.26a1.404 1.404 0 0 0-1.938.993 1.93 1.93 0 0 0 1.112 2.169l16.53 7.26a1.404 1.404 0 0 0 1.938-.993ZM215.163 56.358a1.93 1.93 0 0 0-1.112-2.168l-16.53-7.261a1.405 1.405 0 0 0-1.939.993c-.19.895.275 1.801 1.112 2.17l16.531 7.26a1.404 1.404 0 0 0 1.938-.994ZM213.668 62.264c.19-.895-.275-1.8-1.112-2.169l-16.531-7.26a1.404 1.404 0 0 0-1.938.993c-.19.895.275 1.8 1.112 2.169l16.531 7.26a1.404 1.404 0 0 0 1.938-.993Z",
    fill: "#D6F4DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.869 42.675a9.864 9.864 0 0 0-5.681-11.08l-38.845-17.063c-4.053-1.78-8.718.611-9.638 4.941l-.345 1.623 54.05 23.742.459-2.163Z",
    fill: "url(#img-profile-match-modal_svg__b)",
    stroke: "#000",
    strokeWidth: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.786,
    y: 34.614,
    width: 14.535,
    height: 48.23,
    rx: 7.267,
    transform: "rotate(-15 93.786 34.614)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.644,
    y: 35.109,
    width: 13.135,
    height: 46.83,
    rx: 6.567,
    transform: "rotate(-15 94.644 35.11)",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.305 61.115c4.872 18.182-5.918 36.871-24.1 41.743l-57.442 15.391-.02-.072c-3.3.591-7.832-5.978-10.221-14.895-2.436-9.091-1.723-17.181 1.592-18.07a2.35 2.35 0 0 1 .554-.079l44.456-11.911 45.181-12.107Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.937 85.328 82.12 73.222l45.182-12.107v0c4.872 18.182-5.918 36.871-24.1 41.743L45.759 118.25",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.556,
    y: 29.989,
    width: 14.535,
    height: 48.23,
    rx: 7.267,
    transform: "rotate(-15 82.556 29.99)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m104.397 55.344-5.92-22.097a7.268 7.268 0 0 0-8.901-5.139v0a7.268 7.268 0 0 0-5.14 8.901l10.602 39.567",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.002,
    y: 27.347,
    width: 14.535,
    height: 58.466,
    rx: 7.267,
    transform: "rotate(-15 70.002 27.347)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m93.5 58.88-7.577-28.275a7.268 7.268 0 0 0-8.901-5.14v0a7.268 7.268 0 0 0-5.14 8.902L85.135 83.82",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61.413,
    y: 35.935,
    width: 14.535,
    height: 55.758,
    rx: 7.267,
    transform: "rotate(-15 61.413 35.935)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.896 82.522 63.294 42.955a7.267 7.267 0 0 1 5.139-8.9v0a7.267 7.267 0 0 1 8.9 5.139l5.921 22.096",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.093,
    y: 79.6,
    width: 16.707,
    height: 43.747,
    rx: 8.353,
    transform: "rotate(-60 50.093 79.6)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.534 101.965c-8.922 2.391-17.98.552-25.048-4.287a8.445 8.445 0 0 1-.742-.381l-23.417-13.52a8.353 8.353 0 1 1 8.353-14.469l9.84 5.682",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.403 26.974a7.806 7.806 0 0 1 14.908-3.865 7.804 7.804 0 0 1 12.79 3.755l.081.3a7.17 7.17 0 0 1 10.382 4.426l6.731 25.12 32.846-8.801.176.658c3.222-.099 7.468 6.235 9.744 14.729s1.765 16.103-1.074 17.627l.184.688-51.567 13.818c-8.969 2.403-18.076.563-25.187-4.288a8.98 8.98 0 0 1-.736-.38l.316-.55-.316.55-23.1-13.338a8.875 8.875 0 0 1 8.875-15.372l4.13 2.383-7.414-27.665a7.804 7.804 0 0 1 8.231-9.795Zm12.541 64.258a29.263 29.263 0 0 0 18.048 3.786 33.545 33.545 0 0 1-16.145-3.736 8.22 8.22 0 0 1-1.903-.05Z",
    fill: "url(#img-profile-match-modal_svg__c)",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 132.919,
    y: 24.593,
    width: 14.535,
    height: 48.23,
    rx: 7.267,
    transform: "rotate(-15 132.919 24.593)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 133.776,
    y: 25.088,
    width: 13.135,
    height: 46.83,
    rx: 6.567,
    transform: "rotate(-15 133.776 25.088)",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 121.688,
    y: 19.968,
    width: 14.535,
    height: 48.23,
    rx: 7.267,
    transform: "rotate(-15 121.688 19.968)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m143.529 45.323-5.921-22.097a7.268 7.268 0 0 0-8.901-5.139v0a7.268 7.268 0 0 0-5.139 8.901l10.602 39.567",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 109.132,
    y: 17.326,
    width: 14.535,
    height: 58.466,
    rx: 7.267,
    transform: "rotate(-15 109.132 17.326)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.486 66.889c4.872 18.182 23.561 28.972 41.743 24.1l48.71-13.052-.02-.074c2.881-1.541 3.4-9.257 1.092-17.87-2.308-8.615-6.615-15.037-9.881-14.932l-.012-.045-.262.07a2.359 2.359 0 0 0-.51.136l-40.044 10.73-40.816 10.937Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m132.629 48.86-7.577-28.276a7.266 7.266 0 0 0-8.9-5.139v0a7.267 7.267 0 0 0-5.139 8.9L124.264 73.8",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 100.543,
    y: 25.915,
    width: 14.535,
    height: 55.758,
    rx: 7.267,
    transform: "rotate(-15 100.543 25.915)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m147.668 56.123 41.452-11.107M113.026 72.5l-10.602-39.566a7.267 7.267 0 0 1 5.139-8.9v0a7.268 7.268 0 0 1 8.901 5.139l5.92 22.096",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 89.223,
    y: 69.579,
    width: 16.707,
    height: 43.747,
    rx: 8.353,
    transform: "rotate(-60 89.223 69.58)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m197.942 77.937-52.276 14.008c-8.922 2.39-17.981.552-25.048-4.288a8.359 8.359 0 0 1-.742-.38l-23.418-13.52a8.353 8.353 0 1 1 8.354-14.47l9.841 5.682",
    stroke: "#212121",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.94 60.313a5.856 5.856 0 1 0 0-11.711 5.856 5.856 0 0 0 0 11.71Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.94 59.613a5.156 5.156 0 1 0-.426-10.294 4.339 4.339 0 1 1-4.712 4.712 5.156 5.156 0 0 0 5.138 5.582Z",
    fill: "#B5EEC5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.009 10.677a4.689 4.689 0 1 0 0-9.377 4.689 4.689 0 0 0 0 9.377Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.009 9.977a3.989 3.989 0 1 0-.33-7.964 3.357 3.357 0 1 1-3.645 3.645 3.988 3.988 0 0 0 3.975 4.319Z",
    fill: "#B5EEC5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40.189,
    y: 27.953,
    width: 13.177,
    height: 3.427,
    rx: 1.713,
    transform: "rotate(15 40.19 27.953)",
    fill: "#B5EEC5",
    stroke: "#000",
    strokeWidth: 1.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48.77,
    y: 15.205,
    width: 13.177,
    height: 3.427,
    rx: 1.713,
    transform: "rotate(45 48.77 15.205)",
    fill: "#B5EEC5",
    stroke: "#000",
    strokeWidth: 1.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 173.082,
    y: 22.573,
    width: 13.177,
    height: 3.427,
    rx: 1.713,
    transform: "rotate(150 173.082 22.573)",
    fill: "#B5EEC5",
    stroke: "#000",
    strokeWidth: 1.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-profile-match-modal_svg__a",
    x1: 29.551,
    y1: 48.063,
    x2: 29.551,
    y2: 83.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AD6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-profile-match-modal_svg__b",
    x1: 198.449,
    y1: 10.094,
    x2: 198.449,
    y2: 45.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AD6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img-profile-match-modal_svg__c",
    x1: 134.815,
    y1: 18.471,
    x2: 134.815,
    y2: 96.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AD6CD"
  })))));
};
export default SvgImgProfileMatchModal;